import React, { Component } from 'react'
import { asFlat, toJS } from 'mobx';
import { observer } from 'mobx-react'
import Header from 'components/Answer/Header'
import Main from 'components/Answer/Main'
import Loading from 'components/Common/Loading'
import Consult from 'components/Common/Consult'
import Correction from 'components/Common/Correction'
import Subscribe from 'components/Common/Subscribe'
import { getUserInfo } from 'common/user'

@observer(['answerStore'])
export default class Answer extends Component {
  componentWillReceiveProps (nextProps) {
    const { answerStore } = this.props
    const { location } = nextProps

    if (location.query.page !== this.props.location.query.page) {
      answerStore.changeReport(parseInt(location.query.page, 10) - 1)
    }
  }

  componentDidMount () {
    const { answerStore, location } = this.props

    // 设置背景为白色
    document.body.style.backgroundColor = 'white'
    document.documentElement.style.backgroundColor = 'white'

    answerStore.fetchData(location.query.exerciseId || '')
      .then(() => {
        answerStore.changeReport(parseInt(location.query.page || 1, 10) - 1)
        window.scrollTo(0, 0)
        window.MathJax.Hub.Typeset()
      })
    let info = {
      eventType: 'enterAnswer',
      detailedInfo: {
        exerciseId: sessionStorage.getItem('EXERCISE') || ''
      },
      userId: getUserInfo() ? getUserInfo().id : ''
    }
    window.ssAccess && window.ssAccess.log(info)
  }

  render () {
    const { answerStore } = this.props
    if (!answerStore.currentReport) { return null }
    return (
      <div>
        { answerStore.show.loading ? <Loading /> : null }
        <Consult show={ answerStore.show.askTeacher } onClose={ () => answerStore.toggleAskTeacher(false) } />
        { answerStore.show.correction ?
          <Correction
            questionId={ answerStore.currentReport.id }
            questionName={ answerStore.currentReport.name }
            onClose={ () => answerStore.showCorrection(false) } /> :
            null
        }
        <Subscribe show={ answerStore.show.pigai } onClose={ () => answerStore.togglePigai(false) } />
        <Header
          status={answerStore && answerStore.list[0].reportStatus}
          answerId={answerStore && answerStore.list[0].answerId}
        />
        <Main exam={this.props.params.exam} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Answer/index.js
 **/